export type ValidationType = {
  content: string
  type: string
}
export type ConfidenceAndValidationsType = {
  confidence: number
  validations: ValidationType[]
}

export const ConfidenceAndValidationMappings = {
  weight: {
    UnitDoesNotMatchPattern: 'Unexpected unit',
    UnitUnknown: 'Unknown unit',
    UnitUncertain: 'Uncertain unit',
    WeightExpected: 'Weight expected'
  }
}

export const CONFIDENCE_AND_VALIDATION_TYPES = {
  ATTENTION: 'Attention',
  INFORMATION: 'Information',
  WARNING: 'Warning',
  ERROR: 'Error'
}

// Determine validation type based on confidence value
export const CONFIDENCE_BASED_TYPE = (value: number) => {
  if (value >= 0.7) {
    return CONFIDENCE_AND_VALIDATION_TYPES.INFORMATION
  } else if (value >= 0.5 && value < 0.7) {
    return CONFIDENCE_AND_VALIDATION_TYPES.WARNING
  } else {
    return CONFIDENCE_AND_VALIDATION_TYPES.ATTENTION
  }
}
